import { createContext, useContext } from "react"

// =============================================================================
// Context
// =============================================================================

export type NavigationContextValue = {
  /** Whether the sidebar is currently collapsed */
  collapsed: boolean
  /** Setter to update the collapsed state */
  setCollapsed: (collapsed: boolean) => void
  /** Current pathname (e.g. `/dashboard`) — used by items to derive their own active state */
  currentPath: string
  /** Whether the navigation is rendered in a mobile layout (dock + full-width sidebar) */
  mobile: boolean
}

export const NavigationContext = createContext<NavigationContextValue | null>(null)

export function useNavigationContext(): NavigationContextValue {
  const context = useContext(NavigationContext)
  if (!context) throw new Error("useNavigationContext must be used within a Navigation")
  return context
}
